export default {
  d: "M13,8.8M2,5c0-0.6,0.4-1,1-1h18c0.6,0,1,0.4,1,1v14c0,0.6-0.4,1-1,1H3c-0.6,0-1-0.4-1-1V5z M11.4,8.7L13,8.8V8h5v2h-3\n\tv4h3v2h-5V8.8L11.4,8.7V10h-3v4h3v2h-5v-6l-2,0v8h16V6h-16v4l2,0V8h5V8.7 M11.4,8.7",
  viewBox: "0 0 24 24"
}
